import React, {
    useState
} from 'react';

import { 
   IonPage,
   IonHeader,
   IonContent,
   IonToolbar,
   IonTitle,
   IonGrid,
   IonRow,
   IonCol,
   IonButtons,
   IonButton,
   IonBackButton,
   NavContext,
   IonCard,
   IonCardHeader,
   IonCardSubtitle,
   IonCardTitle,
   IonCardContent,
   IonLabel
} from '@ionic/react';

import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import { hideTab, showTab } from "../components/Tabs";
import PassCheckCtrl from '../components/PassCheckCtrl';
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';



type LockData = {
    lock : string,
    index : any,
    id : any,
    pass : string
};

export default class LockSet extends React.Component<LockData> { 

    static contextType = NavContext;

    state : LockData;

    constructor(props : LockData) {
        super(props);

        this.state = {
            lock: "-- -- --",
            index: 0,
            id: -1,
            pass: ""
        }

        hideTab();
    }

    // confirmation success
    confirmSuccess() {
        showTab();
        this.context.navigate('/mainc', 'root');
    }

    async saveLock()  {

        // read credential
        let v = new Vault();
        await v.read();

        this.state.id = v.account.id;
        this.state.pass = v.account.key;

        var server = new NServer();
        await server.sendForm("save_lock", this.state);

        //DEL console.log("ID-> " + this.state.id + "  Key-> " + this.state.pass);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            this.confirmSuccess();
        }
    }

    passkeyFill() {
        let pos = this.state.lock.search("-");
        return pos >= 0;
    }

    render() {
        // when save the passcode
        const submit = async () => {
            try {
                await this.saveLock();
            } catch (e) {
              console.log(e);
            }
        }

        const setPasskey = (pass : string) => {
            this.state.lock = pass;
        }    

        return (
        <IonPage>
            <IonHeader>
            </IonHeader>
            <IonContent>
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/mainc" ></IonBackButton>
                    </IonButtons>
                    <IonTitle><h5>{ GetStr(LANGUAGE.TXT_SETUP_LOCK_CAP) }</h5></IonTitle>
                </IonToolbar>

                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-padding" size-md="10" size-lg="8" size-xl="6" size="12">
                            { GetStr(LANGUAGE.TXT_SETUP_LOCK_LBL) }
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <PassCheckCtrl onChange={setPasskey} onSubmit={submit} onBiometric={null} />
                         </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
        );
    }
};
